import strings from 'strings';

class ErrorPageModel {
  constructor({ title, subtitle, description }) {
    this.title = title;
    this.subtitle = subtitle;
    this.description = description;
  }
}

export const getErrorPageModel = errorCode => new ErrorPageModel({
  title: strings.pageIsUnaccessible,
  subtitle: !errorCode ? null : `${strings.error} ${errorCode}`,
  description: strings.tryReloadPage,
});
